import React from 'react';
import PropTypes from 'prop-types';
import {FaSwimmingPool} from "react-icons/fa";
export const Title = ({obj}) =>{
	return(
		<>
			<FaSwimmingPool style={{fontSize:'4rem'}}/>
			<span style={{fontSize:'3rem',paddingLeft:'5px',verticalAlign: 'middle'}}>Michael Clinton Swimming Pool</span>
		</>
	)

}
Title.propTypes = {
	obj: PropTypes.object
};
